var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1729 27.1584V62.0703C22.1729 63.6816 23.4912 65 25.1025 65H55.076C56.6874 65 58.0057 63.6816 58.0057 62.0703V17.9297C58.0057 16.3184 56.6874 15 55.076 15H34.3313",
    fill: "#E74C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1729 27.1584H31.4016C33.0129 27.1584 34.3313 25.84 34.3313 24.2287V15",
    fill: "#C0392B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9958 47.7555H22.1731V43.5645L18.709 47.8796H18.7096C18.7682 47.803 18.8673 47.7555 18.9958 47.7555Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1832 47.7555H58.0059V43.5645L61.47 47.8796H61.4694C61.4108 47.803 61.3117 47.7555 61.1832 47.7555Z",
    fill: "#262626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1775 57.0639C58.0831 57.3153 57.7862 57.521 57.5176 57.521H22.6613C22.3928 57.521 22.0958 57.3153 22.0015 57.0639L18.679 48.2125C18.5847 47.9611 18.7272 47.7554 18.9957 47.7554H61.1832C61.4518 47.7554 61.5943 47.9611 61.4999 48.2125L58.1775 57.0639Z",
    fill: "#C0392B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3696 54.9572C31.3696 54.7124 31.4421 54.5235 31.5871 54.3905C31.7321 54.2575 31.9429 54.1909 32.2197 54.1909C32.4831 54.1909 32.6853 54.2575 32.8263 54.3905C32.9673 54.5236 33.0378 54.7125 33.0378 54.9572C33.0378 55.1966 32.9653 55.3835 32.8203 55.5179C32.6752 55.6522 32.4751 55.7194 32.2197 55.7194C31.9562 55.7194 31.7487 55.6529 31.5971 55.5199C31.4455 55.3869 31.3696 55.1993 31.3696 54.9572Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2539 51.6409C38.2539 52.2928 38.0616 52.7963 37.6771 53.1515C37.2927 53.5066 36.7466 53.6843 36.0389 53.6843H35.5959V55.6199H34.0195V49.7852H36.0389C36.7758 49.7852 37.3292 49.9461 37.6991 50.2681C38.0689 50.59 38.2539 51.0477 38.2539 51.6409ZM35.5959 52.3992H35.8833C36.1201 52.3992 36.3083 52.3328 36.448 52.1997C36.5876 52.0666 36.6575 51.8831 36.6575 51.6489C36.6575 51.2552 36.4393 51.0583 36.003 51.0583H35.5959V52.3992Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1363 52.5788C44.1363 53.5525 43.8683 54.3029 43.3321 54.8296C42.796 55.3564 42.0424 55.6199 41.0713 55.6199H39.1836V49.7852H41.203C42.1395 49.7852 42.8625 50.0246 43.3721 50.5035C43.8815 50.9824 44.1363 51.6742 44.1363 52.5788ZM42.5 52.6347C42.5 52.0999 42.3943 51.7035 42.1828 51.4454C41.9712 51.1874 41.6499 51.0583 41.219 51.0583H40.7601V54.3268H41.1112C41.5902 54.3268 41.9413 54.1878 42.1648 53.9098C42.3883 53.6318 42.5 53.2067 42.5 52.6347Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7345 55.6199H45.1821V49.7852H48.6302V51.0502H46.7345V52.1637H48.4826V53.4288H46.7345V55.6199Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6436 33.0576C50.6436 33.4604 50.2041 33.79 49.667 33.79H30.3735C29.8364 33.79 29.397 33.4604 29.397 33.0576C29.397 32.6548 29.8364 32.3252 30.3735 32.3252H49.6671C50.2042 32.3252 50.6436 32.6548 50.6436 33.0576Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6031 37.4521C50.6031 37.855 50.1636 38.1846 49.6265 38.1846H30.333C29.7959 38.1846 29.3564 37.855 29.3564 37.4521C29.3564 37.0493 29.7959 36.7197 30.333 36.7197H49.6266C50.1636 36.7197 50.6031 37.0493 50.6031 37.4521Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6436 41.856C50.6436 42.2588 50.2041 42.5884 49.667 42.5884H30.3735C29.8364 42.5884 29.397 42.2588 29.397 41.856C29.397 41.4531 29.8364 41.1235 30.3735 41.1235H49.6671C50.2042 41.1235 50.6436 41.4531 50.6436 41.856Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.5c4da602836ef36d433584e4a1bbec47.svg";
export { ForwardRef as ReactComponent };